import axios from "axios";
import { parse } from "cookie";
import { getProductQueryServerSide } from ".";
import { getLocationDetail } from "../../../api.services.js/catalouge";
import client from "../../../graphqlClient";
import SubCategory from "../../../src/components/sub-category";
import { categoryValues } from "../category.json";

const tile_size = [
  { tileValue: 264, tileName: "600x600" },
  { tileValue: 262, tileName: "600x1200" },
  { tileValue: 266, tileName: "300x600" },
  { tileValue: 268, tileName: "300x300" },
  { tileValue: 267, tileName: "300x450" },
  { tileValue: 257, tileName: "1200x2400" },
  { tileValue: 455, tileName: "800x2400" },
  { tileValue: 263, tileName: "800x800" },
  { tileValue: 260, tileName: "800x1600" },
  { tileValue: 272, tileName: "195x1200" },
  { tileValue: 258, tileName: "1200x1200" },
  { tileValue: 259, tileName: "1000x1000" },
  { tileValue: 261, tileName: "800x1200" },
  { tileValue: 336, tileName: "400x400" },
  { tileValue: 265, tileName: "395x395" },
  { tileValue: 269, tileName: "295x295" },
  { tileValue: 270, tileName: "250x375" },
  { tileValue: 271, tileName: "200x300" },
  { tileValue: 273, tileName: "145x600" },
  { tileValue: 274, tileName: "200x1200" },
  { tileValue: 335, tileName: "148x600" },
  { tileValue: 480, tileName: "300x1200" },
  { tileValue: 497, tileName: "1200x1800" },
];

/**
 * Server-side function to fetch data for the Bathroom Tiles page.
 *
 * @param {Object} context - The Next.js context object.
 * @returns {Object} An object containing the props to be passed to the page component.
 * @property {boolean} oldComponent - If true, render the old component.
 * @property {Object} oldComponentProps - Props to pass to the old component.
 * @property {boolean} fromPincode - If true, fetch data based on pincode cookie.
 * @property {string} categoryValue - The category value (e.g. "tiles/bathroom-tiles").
 * @property {Object} response - The response from the Unbxd API.
 * @property {Object} sizeProductList - The size products list.
 * @property {string} error - The error message.
 */
export async function getServerSideProps({ query, params, req, resolvedUrl }) {
  let size, // size of the tile;
    type, // type of the tile;
    props = {},
    isSize = false, // size in query exists
    plain = false; // parking

  const cat = "Bathroom Tiles", // category for breadcrumbs
    subCat = query.subCategory.join("/"); // subcategory for breadcrumbs

  props.oldComponentProps = { ...props.oldComponentProps, cat, subCat };

  let { subCategory } = params;

  let unBxdProd, facetsUnbxd, appliedFilterFromUnbxd;

  // parse cookies

  const cookies = parse(req.headers.cookie || "");

  try {
    if (subCategory) size = subCategory[0];

    //convert size name to size value

    tile_size.forEach(({ tileValue, tileName }) => {
      if (tileName === size) {
        size = tileValue;
        isSize = true;
        props.oldComponentProps = {
          ...props.oldComponentProps,
          isSize,
        };
      }
    });

    let newQuery = { ...query, tile_size: size };

    if (subCategory.includes("plain")) {
      plain = true;

      props = { ...props, parking: plain };

      subCategory = ["300x300"];
    }

    if (subCategory.includes("600x1200")) {
      subCategory.includes("walls-tiles") ? (type = "wall") : (type = "floor");

      subCategory = ["600x1200"];
    }

    if (subCategory.length === 1) {
      // proxy server

      let filter = {},
        magentoFilter = {};

      const errorArray = [
        "cat",
        "remc",
        "product_list_order",
        "product_list_dir",
        "mt",
        "trending",
        "tile_finish",
        "aor",
        "tiles_design",
        "tile_color",
        "p",
        "locations",
        ";popularity",
        "application",
        "type_finish",
        "plocation",
        ";trending",
        ";mt",
        "tiles_type",
        "finish",
        "limit",
        "available_region",
      ];

      // check if query params are present
      // if yes, then add them to the filter object
      for (let f of Object.keys(query)) {
        if (f && query[f]) {
          if (
            f != "subCategory" &&
            !isNaN(query[f].split(",")[0]) &&
            !errorArray.includes(f)
          ) {
            filter = {
              ...filter,

              [f]: {
                $in: query[f].split(",").map((cur) => Number(cur)),
              },
            };

            magentoFilter = {
              ...magentoFilter,

              [f]: {
                in: query[f].split(",").map((cur) => Number(cur)),
              },
            };
          }
        }
      }

      filter = {
        ...filter,

        tile_size: { $in: [Number(size)] },
      };

      if (cookies?.pincode) {
        props = { ...props, fromPincode: true };

        const [resp, locationDetail] = await Promise.all([
          axios.post(
            `https://obl-js.orientbell.com/api/products?category=${
              plain ? 102 : 100
            }&pincode=${cookies.pincode}`,
            filter
          ),
          getLocationDetail({
            pincode: cookies.pincode,
          }),
        ]);

        if (locationDetail?.data?.p_location) {
          magentoFilter.plocation = {
            in: [locationDetail.data.p_location.value],
          };
        }

        props.oldComponentProps = {
          ...props.oldComponentProps,
          fromPincode: true,
          ProdBySalesDate: resp.data || [],
          appliedFilters: filter,
          value: plain ? 102 : 100,
          displayLocationPopop: true,
          categoryValue: resolvedUrl.split("?")[0],
          regionData: locationDetail?.data?.p_location || null,
          fitterrss: filter,
          fitterrss2: filter,
          UnbxdResponse: { numberOfProducts: 0, products: [] },
          facetsUnbxd: {},
          appliedFilterFromUnbxd: {},
        };
      } else {
        // no pincode -> Unbxd branch
        const queryParamsArray = Object.keys(newQuery)
          .filter((k) => k !== "subCategory")
          .map((k) => ({
            [k]: isNaN(newQuery[k]) ? newQuery[k] : Number(newQuery[k]),
          }));

        const baseUrl = `https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category`;

        const pId = `p-id=categoryPathId%3A%22${encodeURIComponent(
          resolvedUrl.split("?")[0]
        )}%22`;

        const extras = `&facet.multiselect=true&spellcheck=true&pagetype=boolean&rows=25&start=0&version=V2&fallback=true&viewType=GRID&facet.version=V2`;

        unBxdProd = await axios.get(`${baseUrl}?${pId}${extras}`);

        facetsUnbxd = unBxdProd.data.facets || null;

        appliedFilterFromUnbxd = queryParamsArray.length
          ? queryParamsArray
          : null;

        props.oldComponentProps = {
          ...props.oldComponentProps,
          fromPincode: false,
          UnbxdResponse: unBxdProd.data.response,
          appliedFilters: appliedFilterFromUnbxd,
          facetsUnbxd,
          displayLocationPopop: true,
          appliedFilterFromUnbxd,
          categoryValue: resolvedUrl.split("?")[0],
        };
      }

      let sizeNumber;

      categoryValues.forEach((el) => {
        if (
          el.urlKey === `tiles/bathroom-tiles/${query.subCategory.join("/")}`
        ) {
          sizeNumber = el.id;
        }
      });

      const gqlRes = await client.query({
        query: getProductQueryServerSide,

        variables: {
          filter: {
            category_id: {
              in: [sizeNumber],
            },
            ...magentoFilter,
          },
          sort: { recommended: "ASC" },
          pageSize: props.fromPincode ? 14 : 15,
          currentPage: 1,
        },
      });
      if (
        `tiles/bathroom-tiles/${query.subCategory.join("/")}` ===
        "tiles/bathroom-tiles/600x1200/floor-tiles"
      ) {
        // did this manupulation to show the correct data
        let tempData = {
          ...gqlRes.data,
          products: {
            ...gqlRes.data.products,
            currentcategory: {
              ...gqlRes.data.products.currentcategory,
              meta_title: "Bathroom 600X1200 Floor Tiles",
              meta_description: "Explore Bathroom 600X1200 Floor Tiles",
              description: "",
              dynamic_content: "",
            },
          },
        };
        gqlRes.data = tempData;
      }

      props.oldComponentProps.data = gqlRes.data;
    }
    // subcategory length is more ie more params
    else
      return {
        redirect: {
          destination: `/404`,
          permanent: false,
        },
      };
  } catch (error) {
    console.error(error);
    props = { error: error.message };
  }
  return { props };
}

export default function component(props) {
  if (props.error) {
    return <div>{JSON.stringify(props.error)}</div>;
  }
  return <SubCategory {...props.oldComponentProps} />;
}
